/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Logo_AltInputs */



/**
* | output |
* | --- |
* | "Closed Caption Creator Logo" |
*
* @param {App_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const app_logo_alt = /** @type {((inputs?: App_Logo_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Logo_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Logo de Closed Caption Creator")
	if (locale === "de") return /** @type {LocalizedString} */ ("Logo für Untertitel-Ersteller")
	if (locale === "it") return /** @type {LocalizedString} */ ("Logo del creatore dei sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Логотип создателя субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Logotipo del creador de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕创建器标志")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クローズドキャプションクリエイターロゴ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लोज्ड कैप्शन क्रिएटर लोगो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Logotipo do criador de legendas ocultas")
	return /** @type {LocalizedString} */ ("Closed Caption Creator Logo")
});